import DashboardField from './DashboardField'
import './DashboardTable.scoped.scss'

export default function DashboardRecord ({ dashboardFields, dashboardTarget }) {

  return (
    <div className='dashboard-record'>
      {dashboardFields.map((field, index) => {
        return (
          <DashboardFieldContainer key={index} fieldName={field.name}>
            <DashboardField key={field.id} field={field} dashboardTarget={dashboardTarget} className='dont-grow' />
          </DashboardFieldContainer>
        )})}
    </div>
  )
}

function DashboardFieldContainer({ fieldName, children }) {
  return (
    <div className='dashboard-record-field'>
      <span className='dashboard-record-field-name'>{fieldName}</span>
      <span className='dashboard-record-field-value'>
        {children}
      </span>
    </div>
  )
}
